import { sdkRequest } from '@eventbrite/http';

export const getUser = async () => sdkRequest('/api/v3/users/me/');

export const getUserOrders = async () =>
    sdkRequest(
        '/api/v3/users/me/orders/?time_filter=current_future&expand=event,event.has_digital_content',
    );
